import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled(FlexContainer)`
  width: 358px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;
